import {Component, Input, OnInit} from '@angular/core';
import {EvoAbilityIconImages, EvoItemImages, EvoMonsterImages, ImageCategoryTypes} from '../../../models/questions/shared/imageType.model';
import {EvoImageSelectorService} from './evo-image-selector.service';

@Component({
  selector: 'app-evo-image-selector',
  templateUrl: './evo-image-selector.component.html',
  styleUrls: ['./evo-image-selector.component.css']
})
export class EvoImageSelectorComponent implements OnInit {

  constructor(public sv: EvoImageSelectorService) { }

  ngOnInit() {
  }

  getCategoryImagesWithoutExcludedImages(): string[] {

    const list = [];

    for (const img of this.getCategoryImages()) {
      if (this.sv.imagesToExclude.includes(img) === false) {
        list.push(img);
      }
    }

    return list;

  }

  getCategoryImages(): string[] {

    if (this.sv.category === ImageCategoryTypes.items) {
      return EvoItemImages.list();
    } else if (this.sv.category === ImageCategoryTypes.monsters) {
      return EvoMonsterImages.list();
    } else if (this.sv.category === ImageCategoryTypes.monsterThumbnails) {
      return EvoMonsterImages.list();
    } else if (this.sv.category === ImageCategoryTypes.abilities) {
      return EvoAbilityIconImages.list();
    }

    return [];

  }


}
